import React, {useState} from "react";
import {Icon} from "@blueprintjs/core";

const PasswordInput = (props) => {
    const {
        value,
        setValue,
        style = {},
        placeholder = "",
        label = "",
        showPassword = true,
        onKeyDown = () => {}
    } = props;

    const [inputType, setInputType] = useState(false);

    return (
        <div style={{
            position: "relative",
            ...style
        }}>
            {!!label && <div style={{
                color: "black",
                fontWeight: "bold",
                fontSize: 12,
                marginBottom: 5
            }}>{label}</div>}
            <input
                type={inputType ? "text" : "password"}
                autoComplete="new-password"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholder}
                onKeyDown={onKeyDown}
            />
            {showPassword ?
                <div
                    style={iconStyle}
                    onClick={() => setInputType(inputType => !inputType)}
                >
                    <Icon
                        icon={inputType ? "eye-open" : "eye-off"}
                        iconSize={20}
                    />
                </div> : null
            }
        </div>
    );
};

export default PasswordInput;

const iconStyle = {
    cursor: "pointer",
    position: "absolute",
    top: "31px",
    right: "12px",
    color: "rgb(97, 97, 97)"
}